export default __webpack_public_path__ + "static/media/Red Sox.709295ad.png";